import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { appointmentQKeys } from "@hooks/queries/appointment/queryKeys";
import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { scheduleQKeys } from "@hooks/queries/schedule/queryKeys";


interface MutationProps {
  appointmentId: string;
  formData: FormData;
}

export const useUpdateAppointment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ appointmentId, formData }: MutationProps) => {
      return api.patch(`appointments/${appointmentId}/multipart`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.all() });
      queryClient.invalidateQueries({ queryKey: consultationQKeys.all() });
      queryClient.invalidateQueries({ queryKey: scheduleQKeys.all() });
    },

    onError: (res: any) => {
      console.error("[From Update Appointment]", res);
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.all() });
      queryClient.invalidateQueries({ queryKey: scheduleQKeys.all() });
    },
  });
};
